<template>
  <div class="dropdown input-suggest">
    <transition name="fade">
      <div
          class="dropdown-bg input-suggest-bg"
          v-if="active"
          @click="active = false"
        />
    </transition>
    <input
      v-show="active"
      class="search-input"
      :class="{ 'search-active': valueSelected }"
      ref="search"
      type="text"
      v-model="mainInput"
      :style="`
        width:${width};
        height:${height};
        position: relative;
        z-index: 100;
      `"
      @keyup="getSuggestions"
      @focus="cachedInput !== '' ? mainInput = cachedInput : ''"
    />
    <input
      v-show="!active || valueSelected"
      :class="{ 'search-active-display': active }"
      type="text"
      v-model="displayValue"
      :style="`
        width:${width};
        height:${height};
      `"
      @focus="activate"
    />
    <button class="erase-filter" title="Gebruiker wissen" v-if="displayValue"
      :class="{ 'clear-button-active': active }"
      @click="clear">
      <awesomeIcon icon="times"/>
    </button>
    <table
      :class="{ 'search-active': valueSelected }"
      v-if="active && suggestions.length && mainInput"
      :style="`
        min-width:${parseInt(width) + 20}px;
        min-height:${height};
        top:${height};
      `"
    >
      <tr>
        <th>ID</th>
        <th>Naam</th>
        <th>E-mail adres</th>
        <th>Gebruikersnaam</th>
      </tr>
      <tr
        v-for="suggestion, index in suggestions"
        :key="index"
        title="Selecteren"
        @click="clickedRow(suggestion)"
      >
        <td v-for="label in ['id', 'name', 'email', 'username']" :key="label">
          {{ suggestion[label] }}
        </td>
      </tr>
      <tr class="result-amount" v-if="suggestionAmount > suggestions.length">
        <td colspan="4">
          {{ suggestionAmount - suggestions.length }}
          {{
            suggestionAmount - suggestions.length > 1
              ? 'andere resultaten'
              : 'ander resultaat'
          }}
          gevonden
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: 'InputSuggest',
  emits: ['update:model-value'],
  props: {
    width: {
      type: String,
      default: '150px',
    },
    height: {
      type: String,
      default: '36px',
    },
    cb: {
      type: Function,
      default: () => {},
    },
    modelValue: {
      type: null,
    },
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      mainInput: '',
      displayValue: '',
      open: false,
      active: false,
      cachedInput: '',
      valueSelected: false,
      suggestions: [],
      suggestionAmount: 0,
      timeout: null,
    };
  },
  watch: {
    modelValue() {
      if (this.modelValue === null) {
        this.clear();
      } else if (this.modelValue !== '') {
        this.sdk.getUsers((response) => {
          if (response.status === 200) {
            this.clickedRow(response.data.results[0]);
            this.displayValue = response.data.results[0].email;
          } else {
            this.sdk.logout();
            window.location.reload();
          }
        }, `id eq ${this.modelValue}`, 0, 1);
      }
    },
  },
  methods: {
    clear() {
      this.valueSelected = false;
      this.displayValue = '';
      this.mainInput = '';
      this.cachedInput = '';
      this.$emit('update:model-value', null);
      this.cb(true);
    },
    activate() {
      this.active = true;
      this.$nextTick(() => {
        this.$refs.search.focus();
      });
    },
    clickedRow(user) {
      this.valueSelected = true;
      this.displayValue = user.email;
      this.cachedInput = this.mainInput || '';
      this.mainInput = user.email;
      this.active = false;
      this.$emit('update:model-value', user.id);
      this.cb(true);
    },
    getSuggestions() {
      if (this.mainInput.trim() === '') {
        this.suggestions = [];
        clearTimeout(this.timeout);
        return;
      }

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        let filter = [];

        if (this.mainInput) {
          filter.push(`search contains ${this.mainInput}`);
        }

        if (this.roles.length) {
          filter.push(`role in ${this.roles.join(',')}`);
        }

        filter = filter.join(';');
        this.sdk.getUserIds((response) => {
          if (response.status === 200) {
            this.suggestions = response.data.results;
            this.suggestionAmount = response.data.totalRows;
          } else {
            this.sdk.logout();
            window.location.reload();
          }
        }, filter, 0, 5);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-active {
  transform: translateY(42px);
}
.search-active-display {
  transform: translateY(-32px);
}
.clear-button-active {
  transform: translateY(4px);
}
.input-suggest {
  position: relative;
  input {
    width: 100%;
    height: 100%;
    border-radius: 0;
    padding: 0 10px;
    box-sizing: border-box;
    border: none;
    outline: none;
    &:focus {
      box-shadow: none;
    }
    &.search-input {
      transition: transform 0.15s;
    }
  }
  table {
    width: auto;
    height: auto;
    box-shadow: 0 4px 6px -2px rgb(0 0 0 / 40%);
    position: absolute;
    left: 0;
    z-index: 99;
    border-top-right-radius: 6px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    overflow: hidden;
    margin-top: 2px;
    transition: transform 0.15s;
    tr {
      width: auto;
      height: 36px;
      box-sizing: border-box;
      cursor: pointer;
      padding: 5px 8px;
      border: none;
      &.result-amount:hover {
        background-color: #ffffff;
        cursor: default;
      }
      td {
        white-space: nowrap;
        padding: 7px 10px;
        box-sizing: border-box;
        flex: 1;
      }
      &:hover {
        background-color: #e7eaf0;
      }
      &:first-child:hover {
        background-color: #fff;
        cursor: default;
      }
    }
  }
  .erase-filter {
    background-color: #ffffff;
    border-radius: 0;
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 11px;
    svg {
      color: #000000;
      font-size: 15px;
    }
    &:hover {
      background-color: #e7eaf0;
    }
  }
}
.modal-background {
  background-color: red;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
